export default __webpack_public_path__ + "static/media/gun-industry.7d6b876e.jpg";